import { useState } from "react";
import { Navigate } from "react-router-dom";
import useKeypress from "../ownHooks/pressEsc";
import { App, AppLogin, Footer } from "./AppStyle";

var MonitorApi = require('monitor-api');


function LoginForm ({myApiClient, setToken}) {
    const [name, Setname] = useState();
    const [pw, SetPw] = useState();
        
    const newname = event => {
        Setname(event.target.value);
    }
    
    const newpw = event => {
        SetPw(event.target.value);
    }

    const handleSubmit = e => {
        e.preventDefault();
        console.log(name, pw, myApiClient);
        let HTTPBasic = myApiClient.authentications['HTTPBasic'];
        HTTPBasic.username = name;
        HTTPBasic.password = pw;

        let loginInstance = new MonitorApi.LoginApi(myApiClient);
        let answerLogin = new Promise((resolve) => 
            loginInstance.controlLoginLoginGet((error, data, response) => {
                if (error) {
                    console.log('Fehler');
                    delete HTTPBasic.username;
                    delete HTTPBasic.password;
                    alert('Falsche LoginDaten')
                    resolve();
                } else {
                    setToken(data);
                    sessionStorage.setItem('user', name)
                    sessionStorage.setItem('pw', pw)
                    resolve(data);
                }
            })) //TODO error einpflegen
        answerLogin.then((answer) => {
            if(answer) {
                console.log(answer, myApiClient.authentications)
            }
        })   
    }

    return(
        <form onSubmit={handleSubmit}>
            <label>Benutzer: </label>
            <input className="inputName" type="text" onChange={newname}></input>
            <br />
            <label>Passwort: </label>
            <input className="inputPw" type="password" onChange={newpw}></input>
            <br />
            <button type="submit">Einloggen</button>

        </form>
    )
}

export default function Login ({myApiClient, setToken}) {
    const [pic, setPic] = useState(false);
    const openPic = e => {
        e.preventDefault();
        setPic(!pic);
    }

    useKeypress('Escape', () => {
        alert('Escape, Escape :D ')
    });
    
    if (sessionStorage.getItem('token')) {
        return (
            <Navigate to="/home" />
        )
    } else {
        return (
            <App>
                <header className="App_head">
                    <h1>Ich bin die Startseite</h1>
                    <p>Hier kannst du dich einloggen, wenn du einen Account hast.</p>
                </header>
    
                <AppLogin>
                    <LoginForm myApiClient={myApiClient} setToken={setToken}/>
                </AppLogin>

                <div>
                    <button onClick={openPic}>Drück mich</button>
                    <br></br>
                    {pic && <img id="vci" src="https://www.vcidresden.de/mat/rpic/vci_web2.1.gif" alt="Bild nicht verfügbar"/>}
                </div>
    
                <Footer>
                    Impressum und ähnliches
                </Footer>
            </App>
        )
    }


}